import script from "./IntroductionImage.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroductionImage.vue?vue&type=script&setup=true&lang=js"

import "./IntroductionImage.vue?vue&type=style&index=0&id=03e235f9&lang=scss"

const __exports__ = script;

export default __exports__